import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import { CookieListSection, HeadingSection } from '@app/shared/ui/organisms/Cookies';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { COOKIES_SHOP_PRELOAD_IMAGES } from '@app/assets';
import { DepositSection } from '@app/shared/ui/organisms/Settlements';
import { useDepositSection } from '@app/shared/hooks/useDepositSection';
import { PriceType } from '@app/shared/types/common';

export default function CookiesPage() {
  const isImagesLoading = usePreloadImages(COOKIES_SHOP_PRELOAD_IMAGES);
  const {
    amount,
    scrollRef,
    setAmount,
    isPolling,
    handleTopUp,
    handleSetAmountAndScroll,
    walletAddress,
    isSuccessful,
    isLocked,
    isWallet,
  } = useDepositSection(PriceType.COOKIE);

  if (isImagesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScrollArea className="gap-6">
      <HeadingSection />
      <div className="px-4">
        <DepositSection
          amount={amount}
          onAmountChange={setAmount}
          isTopUpDisabled={!amount || isPolling || !walletAddress}
          onTopUpBtnClick={handleTopUp}
          scrollRef={scrollRef}
          currency={PriceType.COOKIE}
          isSuccessful={isSuccessful}
          isLocked={isLocked}
          isWallet={isWallet}
        />
      </div>

      <CookieListSection onCookiesClick={handleSetAmountAndScroll} />
    </ScrollArea>
  );
}
